import BoilerRating from "./BoilerRating";

export default BoilerRating;